import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import StoreHome from './pages/StoreHome';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import FitAndCare from './pages/FitAndCare';
import AboutVesta from './pages/AboutVesta';
import Sustainability from './pages/Sustainability';
import Wholesale from './pages/Wholesale';
import Ambassador from './pages/Ambassador';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Support from './pages/Support';
import Account from './pages/Account';
import Press from './pages/Press';
import Stockists from './pages/Stockists';
import AdminLogin from './pages/AdminLogin';
import AdminBlog from './pages/AdminBlog';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import { CartProvider } from './context/CartContext';
import { ProductsProvider } from './context/ProductsContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
      <CartProvider>
        <ProductsProvider>
          <BrowserRouter>
          <Routes>
            {/* E-Commerce Site (Main Site) */}
            <Route path="/" element={<StoreHome />} />
            <Route path="/store" element={<StoreHome />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/fit-guide" element={<Navigate to="/fit" replace />} />
            <Route path="/fit" element={<FitAndCare />} />
            <Route path="/about-vesta" element={<AboutVesta />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/ambassador" element={<Ambassador />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/support" element={<Support />} />
            <Route path="/account" element={<Account />} />
            <Route path="/press" element={<Press />} />
            <Route path="/stockists" element={<Stockists />} />

            {/* Admin Blog Manager */}
            <Route path="/admin" element={<Navigate to="/admin/blog" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/blog" element={<ProtectedAdminRoute><AdminBlog /></ProtectedAdminRoute>} />

            {/* Waitlist Landing Page (archived) */}
            <Route path="/waitlist" element={<Home />} />
          </Routes>
        </BrowserRouter>
        </ProductsProvider>
        <Toaster />
      </CartProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;